<nav class="navbar navbar-dark p-2" [ngClass]="isCollapsedMenu ? 'in' : 'out'">
  <div class="navbar-container">
    <!-- Left Section: Profile and Greeting -->
    <div class="navbar-left">
      <!-- Mobile Menu Button -->
      <button type="button" class="mobile-menu-btn" (click)="toggleMobileMenu()" *ngIf="isMobile"
        aria-controls="side-menu" [attr.aria-expanded]="isMobileMenuOpen"
        [attr.aria-label]="isMobileMenuOpen ? (translate.currentLang === 'en' ? 'Close menu' : 'মেনু বন্ধ করুন') : (translate.currentLang === 'en' ? 'Open menu' : 'মেনু খুলুন')">
        <i class="fas" [ngClass]="isMobileMenuOpen ? 'fa-times' : 'fa-bars'"></i>
      </button>
      <app-profile-picture
        [avatarUrl]="currentUser?.avatarUrl || '/assets/images/default-profile-pic.png'"
        [imgSize]="48"
        class="profile-picture-large"
      ></app-profile-picture>
      <div class="greeting-section">
        <h2 class="greeting-text">{{ greeting }}, {{ getUserFullName() }}</h2>
        <p class="greeting-subtext">
          {{
            translate.currentLang === 'en'
              ? "Here's how your investments are performing today."
              : 'আজ আপনার বিনিয়োগ
          কীভাবে পারফর্ম করছে তা এখানে।'
          }}
        </p>
      </div>
    </div>

    <!-- Right Section: Language, Account, Theme Toggle -->
    <div class="navbar-right">
      <!-- Language Switcher -->
      <div class="language-switcher-wrapper">
        <app-language-swicther location="header"></app-language-swicther>
      </div>

      <!-- Account Button -->
      <button class="account-button">
        <i class="fas fa-user" (click)="navigateToProfile()"></i>
        <div class="account-text" (click)="navigateToProfile()">
          <span class="account-name">{{ getUserFullName() }}</span>
          <span class="account-label">{{ translate.currentLang === 'en' ? 'My Account' : 'আমার অ্যাকাউন্ট' }}</span>
        </div>
        <!-- Theme Toggle -->
        <div class="theme-toggle" (click)="toggleDarkMode($event)">
          <div class="theme-toggle-switch" [ngClass]="{ 'dark-active': darkMode }">
            <div class="theme-toggle-slider">
              <i class="fas fa-moon" *ngIf="darkMode"></i>
              <i class="fas fa-sun" *ngIf="!darkMode"></i>
            </div>
          </div>
        </div>
      </button>
    </div>
  </div>
</nav>
